import config from 'app/config';

let translations = {
	en_AU: {

	},
	en_US: {
		"POSTCODE": "ZIP CODE"
	},
	nl_NL: {
		Carrier: "Vervoerder",
		"Delivery Status": "Bezorgstatus",
		REFRESH: "VERVERSEN",
		Refresh: "Verversen",
		"Delivery Details": "BEZORGGEGEVENS",
		Address: "ADRES",
		"Order Number": "BESTELNUMMER",
		Boxes: "PAKKETTEN",
		"Delivery Notes": "NOTITIES BEZORGING",
		"Driver's Notes": "NOTITIES BEZORGER",
		"No driver note": "Geen notities bezorger",
		"Delivery Photos": "FOTO’S BEZORGING",
		"How was your experience?": "HOE WAS JE ERVARING?",
		Submit: "Versturen",
		SUBMIT: "VERSTUREN",
		"Your Delivery Is Estimated To Arrive": "JE PAKKET WORDT DOOR SPOONS ON WHEELS BEZORGD TUSSEN",
		"Contact Details": "CONTACTGEGEVENS",
		"Your delivery was unable to be delivered": "Uw levering kon niet worden afgeleverd"
	},
	de_DE: {
		Carrier: "Spediteur",
		"Delivery Status": "Lieferstatus",
		REFRESH: "AKTUALISIEREN",
		Refresh: "aktualisieren",
		"Delivery Details": "Lieferdetails",
		Address: "Adresse",
		"Order Number": "Bestellnummer",
		Boxes: "Pakete",
		"Delivery Notes": "Lieferhinweise",
		"Driver's Notes": "Lieferschein",
		"No driver note": "Kein Lieferschein",
		"Delivery Photos": "Fotos der Lieferung",
		"How was your experience?": "Wie war Ihre Erfahrung?",
		Submit: "absenden",
		SUBMIT: "ABSENDEN",
		"Contact Details": "Kontaktdetails",
		"Your Delivery Is Estimated To Arrive": "Ihre Lieferung kommt voraussichtlich",
		"Your delivery was unable to be delivered": "Ihre Lieferung konnte nicht zugestellt werden"
	}
};


export const translate = (language, variable) => {
	if (!translations[language]) {
		return variable;
	}

	if (!translations[language][variable]) {
		return variable;
	}

	return translations[language][variable];
}